import { GrailedAPIHeavyListing } from "storefront/Listing/GrailedAPIHeavyListing";
import { GrailedAPILightListing } from "storefront/Listing/GrailedAPILightListing";
import { AlgoliaListing } from "storefront/Listing/AlgoliaListing";
import { AlgoliaInstantSearchListing } from "storefront/Listing/AlgoliaInstantSearchListing";

/**
 * @name soldPriceWithShipping
 * @description Add shipping back to sold price. ONLY for use in our Analytics events
 */
const soldPriceWithShipping = (
  listing:
    | GrailedAPIHeavyListing
    | GrailedAPILightListing
    | AlgoliaInstantSearchListing
    | AlgoliaListing,
): number =>
  listing.soldPriceIncludesShipping
    ? listing.soldPrice
    : listing.soldPrice + (listing.soldShippingPrice || 0);

export default soldPriceWithShipping;
